import React from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Scheda16 = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/app/assets/pdf/SCHEDA-16_Tabelle.pdf'; 
    link.download = 'SCHEDA-16_Tabelle.pdf';
    link.click();
  }
  
  return (<>
    <PageHeader
    title="Scheda 16"
    description="SCHEMA ATTRIBUZIONE TOTALE AZIENDA VAR ALLA SOSTENIBILITÀ E NON"
    className="mb-3"
    >
    </PageHeader>
    
    <Card style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Title>
          </Card.Title>
          <Card.Text>
          <br/><br/><button onClick={handleDownload}>Apri tabella allegata</button>
          </Card.Text>
          <Card.Footer>
              <Link to="/app/metodologia/output">
                <FontAwesomeIcon icon="chevron-left" className="ms-1 fs-11" />&nbsp;&nbsp;&nbsp;
                Torna all'elenco delle schede della fase OUTPUT 
              </Link>
           </Card.Footer>
        </Card.Body>
      </Card>

    </>)
};

export default Scheda16;
